import { Fancybox } from "@fancyapps/ui";
import "./modules/Header";
import "./modules/Slider";
import "./modules/LoopSlider";
import "./modules/Accordion";
import "./modules/BackToTop";
import "./modules/Animation";
import "./modules/Home";
import "./modules/Location";
import "./modules/Marquee";
import "./modules/Plan";


var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

window.lazyLoadInstance = lazyLoadInstance;

Fancybox.bind("[data-fancybox]", {
	// Your custom options
});

$(function () {
	addFirstColumnClass();

	$(window).on("resize", function () {
		addFirstColumnClass();
	});
});

function addFirstColumnClass() {
	const row = $(".row-computed");
	let currentTopPosition = null;

	row.find("> *")
		.removeClass("first-column")
		.each(function () {
			const itemTopPosition = $(this).position().top;

			if (
				currentTopPosition === null ||
				itemTopPosition > currentTopPosition
			) {
				currentTopPosition = itemTopPosition;
				$(this).addClass("first-column");
			}
		});
}
